import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setStatus } from "redux/GeneralReducers/GeneralActions";
import { postRequest, delRequest, putRequest } from "config/axios";
import Buttons from "components/body/buttons/Button";

const ModalJenisArsip = (props) => {
  const dispatch = useDispatch();
  const { GeneralReducers } = useSelector((state) => state);

  const { data, setModal, getList } = props;
  console.log("jenis arsip", data)
  const createJenisArsip = () => {
    dispatch(setLoading(true));
    postRequest(`egs/master/arsip/jenis-arsip`, { ...data.jenisArsip })
      .then(() => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success jenis arsip",
            msg: "Data berhasil ditambah",
          })
        );
        getList();
        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal ditambah" }));
        }
      });
  };

  const updateJenisArsip = () => {
    let id = data.jenisArsip._id;
    dispatch(setLoading(true));
    putRequest(`egs/master/arsip/jenis-arsip/${id}`, { ...data.jenisArsip })
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success jenis arsip",
            msg: "Data berhasil diubah",
          })
        );
        getList();

        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal di ubah" }));
        }
      });
  };

  const deleteJenisArsip = () => {
    let id = data.jenisArsip._id;
    dispatch(setLoading(true));
    delRequest(`egs/master/arsip/jenis-arsip/${id}`)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(
          setStatus({
            status: "success jenis arsip",
            msg: "Data berhasil dihapus",
          })
        );
        getList();

        setModal({ ...data, modal: false });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.request.status === 401) {
          dispatch(setStatus({ status: "401", msg: "Unauthorization" }));
        } else {
          dispatch(setStatus({ status: "fail", msg: "Data gagal di hapus" }));
        }
      });
  };
  return (
    <Fragment>
      <Modal
        size="lg"
        show={data.modal}
        onHide={() => setModal({ modal: false, klasifikasi: {} })}
        aria-labelledby="example-modal-sizes-title-lg"
        animation={false}
      >
        <Modal.Header className="header-modal" closeButton>
          <Modal.Title
            className="title-modal"
            id="example-modal-sizes-title-lg"
          >
            {data.action || "Tambah"} {" "}
            Jenis Arsip
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row reset-margin-row">
            <div className="col-md-12 content-modal">
              <div className="container-fluid">
                {GeneralReducers.status === "fail" && (
                  <div className="alert alert-danger">
                    {GeneralReducers.msg}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="lokasi">Kode*</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={data.action === "Delete"}
                    defaultValue={data.jenisArsip && data.jenisArsip.kode}
                    onChange={(e) =>
                      setModal({
                        ...data,
                        jenisArsip: {
                          ...data.jenisArsip,
                          kode: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lokasi">Nama*</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={data.action === "Delete"}
                    defaultValue={data.jenisArsip && data.jenisArsip.nama}
                    onChange={(e) =>
                      setModal({
                        ...data,
                        jenisArsip: {
                          ...data.jenisArsip,
                          nama: e.target.value,
                        },
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row reset-margin-row ">
            <div className="col-md-12 text-right mb-3">
              {GeneralReducers.loading && (
                <i className="fa fa-spinner fa-pulse fa-fw cover-empty mr-2"></i>
              )}
              {data.action === "Delete" && (
                <Buttons
                  onClick={deleteJenisArsip}
                  className="btn btn-danger pull-left"
                >
                  Hapus
                </Buttons>
              )}
              <Buttons
                className="btn btn-default mr-2"
                onClick={() => setModal({ modal: false, klasifikasi: {} })}
              >
                Batal
              </Buttons>

              <Buttons
                onClick={() => {
                  if (data.action === "Tambah") {
                    createJenisArsip();
                  } else if (data.action === "Ubah") {
                    updateJenisArsip();
                  }
                }}
                className="btn btn-primary mr-2"
                disabled={GeneralReducers.loading || data.action === "Delete"}
              >
                Simpan
              </Buttons>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ModalJenisArsip;
